import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { ActivityCountState } from "../../models/mp-admin/activity-count-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class ActivityCountsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.activityCounts.get),
			withLatestFrom(this.store.select(MpAdminSelectors.activityCounts)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.activityCounts.getSuccess(state))
					: of(MpAdminActions.activityCounts.getApi({ count: action.count }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.activityCounts.getApi),
			switchMap((action) =>
				this.adminService.activityCounts(action.count).pipe(
					map(
						(counts) =>
							MpAdminActions.activityCounts.getSuccess({ counts, loading: false }),
						catchError((error) =>
							of(MpAdminActions.activityCounts.getFail(new FailState(error)))
						)
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private adminService: MpAdminService,
		private actions: Actions
	) {}

	private canUseStoreValue(action, state: ActivityCountState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
